module.exports = __webpack_public_path__ + "assets/images/kaffee_in_zahlen_2017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/cover/kaffee_in_zahlen_2017.jpg
// module id = 981
// module chunks = 0